import { Instagram, Facebook, MapPin, Mail } from "lucide-react";
import { BRAND, waLink } from "../../lib/site";
import Logo from "./Logo";

export const Footer = () => {
  return (
    <footer className="bg-ink text-cream/80 pt-20 pb-10">
      <div className="container-narrow">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-14 border-b border-cream/10">
          <div className="md:col-span-5">
            <p className="overline text-gold-soft">Indore · Heritage saree boutique</p>
            <div className="mt-4">
              <Logo variant="light" size="lg" showHindi withBranch />
            </div>
            <p className="mt-5 italic font-serif text-cream/75 text-lg">
              "{BRAND.tagline}"
            </p>
            <p className="mt-4 max-w-md text-cream/65 leading-relaxed text-sm">
              Hand-curated drapes for weddings, festivals & every quiet moment
              in between. Visit our boutique on Airport Road, Indore — or
              message us, we'd love to dress your story.
            </p>
            <a
              href={waLink("Hi! I'd like to chat about your sarees.")}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-cta"
              className="btn-ghost mt-8 inline-flex"
            >
              Message on WhatsApp
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-gold-soft">Explore</p>
            <ul className="mt-5 space-y-3 text-cream/80">
              <li><a href="#collection" className="hover:text-gold transition-colors">Collection</a></li>
              <li><a href="#categories" className="hover:text-gold transition-colors">Categories</a></li>
              <li><a href="#story" className="hover:text-gold transition-colors">Our Story</a></li>
              <li><a href="#visit" className="hover:text-gold transition-colors">Visit Boutique</a></li>
              <li><a href="#contact" className="hover:text-gold transition-colors">Inquiry</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-gold-soft">Reach us</p>
            <ul className="mt-5 space-y-3 text-cream/80 text-sm">
              <li>
                <a href={`tel:+${BRAND.whatsappNumber}`} className="hover:text-gold">
                  WhatsApp · {BRAND.whatsappDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  data-testid="footer-email-link"
                  className="hover:text-gold inline-flex items-center gap-2 break-all"
                >
                  <Mail size={14} /> {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.maps}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-gold inline-flex items-start gap-2"
                >
                  <MapPin size={14} className="mt-1 shrink-0" />
                  <span>
                    {BRAND.address.line1}, <br />
                    {BRAND.address.line2}, {BRAND.address.city}
                  </span>
                </a>
              </li>
            </ul>

            <div className="mt-7 flex items-center gap-3">
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 border border-cream/20 flex items-center justify-center hover:bg-gold hover:text-ink hover:border-gold transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href={BRAND.facebook}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 border border-cream/20 flex items-center justify-center hover:bg-gold hover:text-ink hover:border-gold transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-cream/55">
          <p>© 2026 {BRAND.name}. Crafted with care.</p>
          <p className="tracking-[0.25em] uppercase">Heritage · Heart · Handlooms</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
